import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../../TableTemplate/tableTemplate";
import { useState } from "react";
import { IExeStatusTableReport } from "../../../../Interfaces/adjustment";
import Button from "../../../../Components/Button";
import Modal from "../../../../Components/Modal/Modal";
import OrdersTable from "./OrdersTable";
import { cancelOrders, sendOrders } from "../../../../Requests/adjustment";
import { packetErrorHandler } from "../../../../Utils/requestUtils";
import { toast } from "react-toastify";
import FullScreenLoading from "../../../../Components/Loading/FullScreenLoading";
import ErrorsTable from "./ErrorsTable";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">پیشنهاد</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">سفارش</span>
      </TableCell>
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
    </>
  );
};

enum ModalMode {
  Orders,
  Errors,
  Closed,
}

const AdditionalCol: React.FC<{
  row: IExeStatusTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [loading, setLoading] = useState(false);
  const sendOrdersHandler = () => {
    setLoading(true);
    sendOrders(row.orderDto)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  const cancelOrdersHandler = () => {
    setLoading(true);
    cancelOrders(row.orderDto)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      <TableCell>
        <div>{row.offer}</div>
      </TableCell>
      <TableCell>
        <Button
          text="ارسال"
          onClick={sendOrdersHandler}
          variant="contained"
          disabled={!row.active}
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            onClose={() => setModalMode(ModalMode.Closed)}
            UI={
              modalMode === ModalMode.Orders ? (
                <OrdersTable taskId={row.taskId} adjusmentExeTab={row.exeTab} />
              ) : modalMode === ModalMode.Errors ? (
                <ErrorsTable taskId={row.taskId} adjusmentExeTab={row.exeTab} />
              ) : (
                <></>
              )
            }
          />
        ) : (
          <></>
        )}
        <div>{row.order}</div>
      </TableCell>
      <TableCell>
        <Button
          text="سفارشات"
          onClick={() => setModalMode(ModalMode.Orders)}
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        <Button
          text="خطا ها"
          onClick={() => setModalMode(ModalMode.Errors)}
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        <Button
          text="کنسل"
          onClick={cancelOrdersHandler}
          variant="contained"
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IExeStatusTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
